import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CENAddressValidationState from "@tCentro/Store/Reducer/CENAddressValidationState";


import { Draft } from "immer";
 
const initialState: CENAddressValidationState = {
    isErrorOccured:false ,
    smartyErrorMessage: ''
};
export default createTypedReducerWithImmer(initialState, {
    "Custom/AddressValidation/SetAddressValidationError": (
        draft: Draft<CENAddressValidationState>,
        action: { isErrorOccured: boolean, smartyErrorMessage: string },
    ) => {
        draft.isErrorOccured = action.isErrorOccured;
        draft.smartyErrorMessage = action.smartyErrorMessage
    },
});